module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"message":"By using this site you agree to the use of cookies for analytics and personalized content.","link_text":"Read our privacy policy","accept":"Got it!"},"de":{"message":"Mit der Nutzung dieser Webseite erklären Sie, dass Sie der Nutzung von Cookies zur Verbesserung und Personalisierung unseres Angebotes zustimmen.","link_text":"Lesen Sie unsere Datenschutzerklärung","accept":"Akzeptieren"}}')
  delete Component.options._Ctor
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/@kazupon/vue-i18n-loader/lib!./node_modules/yaml-loader!./node_modules/vue-loader/lib/selector.js?type=customBlocks&index=0!./src/components/CookieConsent.vue
// module id = 0LAs
// module chunks = 0